import { Icons } from "../assets/icons/Icons";
import Button from "./Button"; // Assuming we're using the Button component from earlier
import "./styles/CardPromoModal.css";

const PromoCard = ({
    title = "GET YOUR MAPEX CARD NOW!",
    subtitle = "Join our Waitlist to be the first to hear when our cards become available",
    image,
    bgImage,
    primaryButtonText = "Join Our Waitlist",
    secondaryButtonText = "Learn More",
    onPrimaryClick,
    onSecondaryClick,
    className = "",
    onClose,
}) => {
    return (
        <div
            className={`promo-card ${className}`}
            style={{
                backgroundImage: `url(${bgImage})`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "0px 0px",
                backgroundSize: "cover",
                backgroundColor: "#000000",
            }}
        >
            <div className="promo-card-content">
                <div className="close-button-container">
                    <div
                        className="close-button"
                        onClick={onClose}
                        aria-label="Close"
                    >
                        <Icons.CloseWithBG />
                    </div>
                </div>

                <div className="promo-image-wrapper">
                    <div className="promo-image-container">
                        <img
                            src={image || "/placeholder.svg"}
                            alt="Promotional"
                            className="promo-image"
                        />
                    </div>
                </div>

                <div className="promo-text-content">
                    {title && <h2 className="promo-title">{title}</h2>}
                    {subtitle && <p className="promo-subtitle">{subtitle}</p>}
                </div>

                <div className="promo-actions">
                    <Button
                        variant="primary"
                        onClick={onPrimaryClick}
                        fullWidth={true}
                    >
                        {primaryButtonText}
                    </Button>

                    <Button
                        variant="black"
                        onClick={onSecondaryClick}
                        fullWidth={true}
                        className="secondary-button"
                    >
                        {secondaryButtonText}
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default PromoCard;
